import { render, staticRenderFns } from "./BirSalesReport.vue?vue&type=template&id=1da34e56&"
import script from "./BirSalesReport.vue?vue&type=script&lang=js&"
export * from "./BirSalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports